module.exports = __webpack_public_path__ + "img/2.5e4e7c16.png";